import React from "react";

const searchStyle = {
  display: "flex",
  flexDirection: "column",
};

function Search({ onQueryChange, query }) {
  const getLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((loc) => {
        fetch(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${loc.coords.latitude}&longitude=${loc.coords.longitude}&localityLanguage=de`
        )
          .then((response) => response.json())
          .then((result) => {
            onQueryChange(result.city);
          })
          .catch(() => alert("Das hat nicht funktioniert."));
      });
    } else {
      alert("Dein Browser unterstützt keinen Standortzugriff.");
    }
  };

  const getCityOfContact = async () => {
    if ("contacts" in navigator) {
      const props = ["name", "address"];

      try {
        const contact = await navigator.contacts.select(props, {});
        onQueryChange(contact[0].address[0].addressLine[0]);
      } catch (ex) {
        alert("Das hat nicht funktioniert.")
      }
    } else {
      alert("Dein Browser unterstützt keinen Kontaktzugriff.");
    }
  };

  return (
    <section style={searchStyle}>
      <label htmlFor="search">Suche: </label>
      <input
        id="search"
        type="text"
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
      />
      <button onClick={() => getLocation()}>Standort bestimmen</button>
      <button onClick={() => getCityOfContact()}>
        Nach Standort eines Kontakts suchen
      </button>
    </section>
  );
}

export default Search;
